// Step 23 — clauses included.
//
// Reads `detail.clauses_included` verbatim. Backend does not currently
// expose a first-class ContractClause model, so we deliberately stay
// at the AI-emitted list level (per the drafting schema in
// backend/ai_native/contracts/drafting.py). No fake clause-level diff,
// no fabricated clause coverage percentage.

import { AIEmpty, AISection } from "../AIPrimitives";
import { normalizeContractClauses } from "./helpers";

export default function AIContractClauses({ detail }) {
  const clauses = normalizeContractClauses(detail?.clauses_included);
  if (clauses.length === 0) {
    return (
      <AISection title="Klausuler i utkastet">
        <AIEmpty
          title="Inga klausuler registrerade av drafting-tjänsten"
          hint="Utkastets faktiska innehåll finns i avtalstexten längre ned."
        />
      </AISection>
    );
  }
  return (
    <AISection
      title="Klausuler i utkastet"
      right={
        <span className="qai-page-section-hint">
          {clauses.length} post{clauses.length === 1 ? "" : "er"}
        </span>
      }
    >
      <ul className="qai-contract-clauses">
        {clauses.map((c) => (
          <li key={c.key} className="qai-contract-clause-row">
            <div className="qai-contract-clause-name">{c.name}</div>
            {c.source && (
              <div className="qai-contract-clause-source">
                Källa: {c.source}
              </div>
            )}
          </li>
        ))}
      </ul>
    </AISection>
  );
}
